import React, { useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../firebase";
import Toast from "../components/Toast/Toast";
import "../styles/Register.css"; // Or Login.css, whichever matches

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [toast, setToast] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const showToast = (message, type = "info") => {
    setToast({ message, type });
  };

  const handleReset = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    showToast("", "info");
    try {
      await sendPasswordResetEmail(auth, email);
      showToast("Password reset email sent!", "success");
    } catch (err) {
      let msg = "Failed to send password reset email.";
      if (err.code === "auth/user-not-found") {
        msg = "No account found with that email.";
      }
      showToast(msg, "error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="register-wrapper">
      <form className="register-form" onSubmit={handleReset}>
        <h2>Reset Password</h2>
        <input
          type="email"
          placeholder="Enter your email"
          value={email}
          autoComplete="username"
          onChange={(e) => setEmail(e.target.value)}
          required
          disabled={isLoading}
        />
        <button type="submit" disabled={isLoading}>
          {isLoading ? "Sending..." : "Send Reset Link"}
        </button>
        <div style={{ marginTop: "1.2rem", width: "100%" }}>
          <a
            href="/login"
            style={{
              color: "#a67800",
              textDecoration: "underline",
              fontSize: "0.98rem",
            }}
          >
            Back to login
          </a>
        </div>
      </form>
      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast(null)}
        />
      )}
    </div>
  );
}
